import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { VoucherCodeWidgetComponent } from './components/voucher-code-widget/voucher-code-widget.component';
import {LibDirectivesModule} from '@utils/directives/lib-directives.module';

@NgModule({
  declarations: [
    VoucherCodeWidgetComponent,
  ],
  imports: [
    CommonModule,
    LibDirectivesModule,
  ],
  exports: [
    VoucherCodeWidgetComponent
  ]
})
export class SharedWidgetsModule { }
